import { feedTitleKeys } from 'shared/helpers'

export const showFeedInspection = ({ feeds = [], currentFeedName = '' }) => {
  const finalizedInpectionFeed = feeds.find(
    feed => feed.name === feedTitleKeys.INSPECTION_FINALIZED,
  )

  if (
    !finalizedInpectionFeed &&
    currentFeedName === feedTitleKeys.INSPECTION_CREATED
  ) {
    return true
  }

  return false
}
